import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiGlobe = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 1.15137,
			y: .999878,
			width: 26,
			height: 26,
			rx: 13,
			fill: "url(#paint0_linear_7_1102)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1.15137,
			y: .999878,
			width: 26,
			height: 26,
			rx: 13,
			stroke: "white",
			strokeWidth: 1.5443
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3713 6.5102C20.6598 6.47956 21.0516 6.50987 21.3469 6.80512C21.608 7.06664 21.6615 7.40554 21.6496 7.67231C21.6375 7.94097 21.5585 8.22614 21.4513 8.50336C21.2351 9.06242 20.8452 9.73932 20.3381 10.4799C20.2597 10.5943 20.1757 10.709 20.091 10.8276C20.5911 11.7696 20.8751 12.8439 20.8752 13.9848C20.8752 17.7096 17.8558 20.7289 14.131 20.7289C12.9897 20.7289 11.9151 20.4443 10.9728 19.9438C10.8565 20.0269 10.7443 20.11 10.632 20.187C9.89124 20.6942 9.21362 21.083 8.65447 21.2993C8.37738 21.4064 8.09295 21.4854 7.82439 21.4975C7.59089 21.5079 7.30164 21.4687 7.05779 21.2836L6.95623 21.1957L6.85857 21.0815C6.658 20.8092 6.63474 20.4837 6.65936 20.2338C6.68844 19.939 6.79246 19.6202 6.93084 19.3022C7.19052 18.7055 7.63174 17.985 8.19744 17.1918C7.68088 16.238 7.38689 15.1457 7.38689 13.9848C7.38706 10.2603 10.4066 7.24095 14.131 7.24067C15.2914 7.24067 16.3836 7.53409 17.3371 8.05024C18.1202 7.4914 18.8318 7.0549 19.423 6.7934C19.7476 6.64991 20.0724 6.54204 20.3713 6.5102ZM8.95916 18.3129C8.55892 18.9038 8.2683 19.4097 8.0949 19.808C8.02623 19.9659 7.98212 20.0945 7.95525 20.1948C8.02165 20.177 8.10254 20.1524 8.19744 20.1157C8.60809 19.9568 9.16416 19.6452 9.83904 19.1879C9.5195 18.924 9.22526 18.6306 8.95916 18.3129ZM19.2238 11.9731C18.9328 12.3387 18.6206 12.7174 18.2873 13.1039C18.35 13.2662 18.3859 13.442 18.3859 13.6264C18.3859 14.4285 17.7358 15.0793 16.9338 15.0795C16.7956 15.0795 16.6619 15.0589 16.5353 15.0229C16.3154 15.2511 16.091 15.4809 15.8615 15.7104C14.5659 17.006 13.28 18.1531 12.1193 19.0766C12.7423 19.323 13.4205 19.4603 14.131 19.4604C17.1551 19.4604 19.6066 17.0089 19.6066 13.9848C19.6066 13.2743 19.4701 12.596 19.2238 11.9731ZM14.131 8.50922C11.1073 8.5095 8.65561 10.9611 8.65545 13.9848C8.65545 15.8045 9.54433 17.4159 10.9103 18.4116C12.1262 17.4795 13.5326 16.2463 14.965 14.8139C15.1778 14.6012 15.3853 14.3882 15.589 14.1772C15.5195 14.0074 15.4806 13.8212 15.4806 13.6264C15.4809 12.8244 16.1317 12.1743 16.9338 12.1743C17.0816 12.1743 17.2242 12.1967 17.3586 12.2377C17.7994 11.725 18.2011 11.2305 18.5588 10.7641C17.5631 9.39782 15.951 8.50922 14.131 8.50922ZM20.3449 7.80512C20.2395 7.83346 20.1039 7.87964 19.9367 7.95356C19.5397 8.12909 19.0389 8.4177 18.4572 8.81195C18.7761 9.07887 19.0704 9.37403 19.3351 9.69477C19.7951 9.01663 20.1084 8.45744 20.2678 8.04535C20.304 7.95146 20.3272 7.87108 20.3449 7.80512Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7_1102",
			x1: 1.04483,
			y1: .999896,
			x2: 28.6178,
			y2: 2.79145,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF65DD" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#B752FF"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgAiGlobe);
export default ForwardRef;
